// Hold the action(s) around Signing Statements
import { queryGraphQL } from 'common/util/query';
import { node, nodeWithArgs, toQuery, toMutation } from 'common/util/queryHelper';
import { addApplicationMessages } from 'common/actions/applicationMessagesActions';
import { replace } from 'react-router-redux';
import { binderInstitutionIdSelector } from 'common/selectors';

export const ACTIONS = {
    PART11_SIGNING_STATEMENTS: 'PART11_SIGNING_STATEMENTS',
    PART11_SIGN_DOCUMENT: 'PART11_SIGN_DOCUMENT'
};

export function loadSigningStatements() {

    return (dispatch, getState) => {
        const state = getState();
        const institutionId = binderInstitutionIdSelector(state);

        if (!institutionId) {
            return;
        }

        const query = nodeWithArgs('signingStatements', {
            institutionId
        }, ['id', 'name', 'statement']);

        return queryGraphQL(toQuery(query)).then(response => {
            if (response.errors) {
                dispatch(addApplicationMessages('error', response.errors.map(e => e.message)));
            } else {
                dispatch({
                    type: ACTIONS.PART11_SIGNING_STATEMENTS,
                    payload: response.data.signingStatements
                });
            }
        });
    };
}

export function signDocument(documentId, statementId, signingToken, binderId) {
    return (dispatch, getState) => {
        const state = getState();
        const institutionId = binderInstitutionIdSelector(state);
        const signDocumentMutation = nodeWithArgs('signDocument', {
            documentId, binderId, institutionId, statementId, signingToken
        }, [
            node('signatures', [
                node('statement', [
                    'id',
                    'name',
                    'statement'
                ]),
                node('user', [
                    'sub',
                    'name',
                    'emailAddress'
                ]),
                'dateSigned'
            ])
        ]);
        const mutation = toMutation(signDocumentMutation);

        return queryGraphQL(mutation).then(results => {
            if (results.errors) {
                dispatch(addApplicationMessages('error', results.errors.map(e => e.message)));
            } else {
                dispatch(replace(`/binder/${binderId}/files/${documentId}`));
            }
        });
    };
}
